// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"BoxButton_buttonsContainer__2RK0x","buttonMargin":"BoxButton_buttonMargin__3TIGw"};